import * as actions from './RailsLandingActionTypes';
import {ACTION_SET_PPBOOKING_LANDING_DATA} from '../../Review/RailsReviewActions';
import {now} from '@mmt/legacy-commons/Helpers/dateHelpers';
import { getRailsLanguageByKey } from '../../../vernacular/AppLanguage';

const userAccountCreationInitState = {
  userName: null,
  password: null,
  securityQuestion: null,
  securityAnswer: null,
  selectLanguage: null,
  enterFirstName: null,
  enterLastName: null,
  selectGender: null,
  enterEmail: null,
  enterMobileNumber: null,
  enterDob: null,
  selectOccupation: null,
  selectMaritalStatus: null,
  selectNationality: null,
  enterResidentialAddress: null,
  enterResidentialMobileNumber: null,
  enterPinCode: null,
  selectCity: null,
  selectState: null,
  selectPostOffice: null,
  country: null,
  enterOfficeAddress: null,
  enterOfficeMobileNumber: null,
  enterOfficePinCode: null,
  selectOfficeCity: null,
  selectOfficeState: null,
  selectOfficePostOffice: null,
  officeCountry: null,
  officeCheckBoxEnabled: true,
  cmp: null,
  enterCaptcha: null,
  greq:'',
  userDataLoader:false
};

const initialState = {
  originStation: null,
  destinationStation: null,
  departureDate: now(),
  travelByAc: false,
  fcStripIndex:0,
  selectedClass: 'ALL',
  appState: 'active',
  offers: [],
  otherOffers: [],
  userAccount: userAccountCreationInitState,
  recentSearches: [],
  securityQuestionList: [],
  occupationList: [],
  dateSetFromURL: true,
  LocusDetails: {
    fromLocusCode : null ,
    toLocusCode : null,
    fromLobCode : null,
    toLobCode : null,
    fromStationName : null,
    toStationName : null,
    sourceLocusType : null,
    destinationLocusType : null,
    sourceLocusV2Id : null,
    sourceLocusV2Type : null,
    destinationLocusV2Id : null,
    destinationLocusV2Type : null,
  },
  sectionOrder: [],
  risOptions: [],
  sortedSectionList: [],
  ltsDate: {},
  boardingData: {},
  startDateOptionSelected: true,
  isLoading: false,
  redirectedFromSeo: false,
  scheduleTatkalForms: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.ACTION_ON_ORIGIN_SELECTED: {
      return {
        ...state,
        originStation: {
          ...action.data,
          language: getRailsLanguageByKey("cookieCode")
        },
        liveStationViewState: 'loading'
      };
    }
    case actions.ACTION_RESET_RAIL_LANDING: {
      return {
        ...state,
        ...action.data
      };
    }

    case actions.ACTIONS_RAILS_SCHEDULE_TATAKAL_ALL_FORMS: {
      return {
        ...state,
        ...action.data,
      };
    }

    case actions.ACTION_ON_DESTINATION_SELECTED: {
      return {
        ...state,
        destinationStation: {
          ...action.data,
          language: getRailsLanguageByKey("cookieCode"),
        }
      };
    }
    case actions.ACTION_ADD_USER_DATA: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          ...action.data
        }
      };
    }
    case actions.ACTION_NEW_ACCOUNT_OFFICE_BUTTON_TOGGLE: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          officeCheckBoxEnabled: action.data
        }
      };
    }
    case actions.ACTION_USER_ACCOUNT_VALIDATION_FAIL: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          ...action.data
        }
      };
    }
    case actions.ACTION_SWAP_SEARCH: {
      const {originStation, destinationStation} = state;
      return {
        ...state,
        originStation: destinationStation,
        destinationStation: originStation
      };
    }
    case actions.ACTION_AC_BUTTON_TOGGLE: {
      const {data: acState} = action;
      return {
        ...state,
        travelByAc: acState
      };
    }
    case actions.ACTION_UPDATE_FREE_CANCELLATION_OPTION: {
      const {data: isFreeCancellationEnabled} = action;
      return {
        ...state,
        ...isFreeCancellationEnabled
      };
    }
    case actions.ACTION_DATE_SELECTED: {
      const {data: date} = action;
      return {
        ...state,
        departureDate: date
      };
    }
    case actions.ACTION_APP_STATE_CHANGE: {
      return {
        ...state,
        appState: action.data
      };
    }
    case ACTION_SET_PPBOOKING_LANDING_DATA: {
      return {
        ...state,
        ...action.data
      };
    }
    case actions.ACTION_SET_RAILS_OFFERS: {
      const {data: offers} = action;
      return {
        ...state,
        offers
      };
    }

    case actions.ACTION_SET_OTHER_OFFERS: {
      const {data: otherOffers} = action;
      return {
        ...state,
        otherOffers
      };
    }

    case actions.ACTION_ON_ADD_RECENT_SEARCHES: {
      const {data: recentSearch} = action;
      return {
        ...state,
        recentSearches: recentSearch
      };
    }
    case actions.ACTION_SET_PIN_CODE_DATA: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          ...action.data
        }
      };
    }
    case actions.ACTION_SET_TO_INIT_STATE_USER_DATA: {
      return {
        ...state,
        userAccount: userAccountCreationInitState
      };
    }
    case actions.ACTION_MMT_HIGHLIGHTS: {
      return {
        ...state,
        ...action.data
      };
    }
    case actions.ACTION_FILL_USER_DATA: {
      const {securityQuestionList, occupationList} = action.data;
      const [securityQuestion] = securityQuestionList;
      const [selectOccupation] = occupationList;
      return {
        ...state,
        securityQuestionList,
        occupationList,
        userAccount: {
          ...state.userAccount,
          securityQuestion,
          selectOccupation
        }
      };
    }

    case actions.ACTION_UPDATE_LANDING_DETAILS: {
      const {
        origin, destination, departureDate, shouldDateBeUpdatedFromURL
      } = action.data;
      return {
        ...state,
        dateSetFromURL: shouldDateBeUpdatedFromURL,
        originStation: origin,
        destinationStation: destination,
        departureDate
      };
    }

    case actions.ACTION_SET_LOCUS_DETAILS : {
      const {LocusDetails} = action.data;
      return {
        ...state,
        LocusDetails
      }
    }
    case actions.ACTION_OPEN_TRAIN_PICKER: {
      const {trainName, trainNumber} = action.data;
      return {
        ...state,
        trainDetail: {
          trainName,
          trainNumber
        }
      };
    }

    case actions.ACTION_OPEN_DATE_PICKER: {
      const {dateTitle, dateFormatted, dateFormattedMini, dateNumeric, date} = action.data;
      return {
        ...state,
        dateDetail: {
          dateTitle,
          dateFormatted,
          dateFormattedMini,
          dateNumeric,
          date
        }
      };
    }

    case actions.ACTION_OPEN_STATION_PICKER: {
      const { stationCode,stationName } = action.data;
      return {
        ...state,
        stationDetail:{
          stationCode,
          stationName
        }
      }
    }

    case actions.ACTION_UPDATE_BOOKING_SOURCE: {
      const {cmp} = action.data;
      return {
        ...state,
        cmp
      };
    }

    case actions.ACTION_UPDATE_SELECTED_CLASS: {
      const {selectedClass} = action.data;
      return {
        ...state,
        selectedClass
      };
    }
    case actions.ACTION_FETCH_SECTION_ORDERS_INIT:
      return {
        ...state,
        sectionOrderLoading: true,
      }
    case actions.ACTION_FETCH_SECTION_ORDERS_FAILED:
    case actions.ACTION_FETCH_SECTION_ORDERS_SUCCESS:
      return {
        ...state,
        sectionOrderLoading: false,
        sectionOrder: action.payload.sectionOrder,
      }

    case actions.ACTION_FETCH_RIS_OPTION_SUCCESS_WEB:
    case actions.ACTION_FETCH_RIS_OPTION_SUCCESS_APP:
      return {
        ...state,
        risOptions: action.payload,
      };
    case '@rails/SET_VERNACULAR_STATUS':
      return {
        ...state,
        sectionOrder: [],
        // configData: {},
      };
    case actions.ACTION_SET_USER_DATA_LOADER: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          ...action.data,
        },
      };
    }
    case actions.ACTION_SET_CAPTCHA_NULL: {
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          ...{ enterCaptcha: null },
        },
      };
    }
    case actions.ACTION_SET_SESSION_ID_AND_CAPTCHA: {
      const {captchaQuestion, status,captchaLoading,captchaDowntimeError} = action.data;
      return {
        ...state,
        userAccount: {
          ...state.userAccount,
          captchaQuestion,
          status,
          captchaLoading,
          captchaDowntimeError,
        },
      };
    }
    case actions.ACTION_UPDATE_LTS_DATE: {
      return {
        ...state,
        ltsDate : action.data,
      };
    }
    case actions.ACTION_UPDATE_LTS_BOARDING_DATA: {
      return {
        ...state,
        boardingData : action.data,
      };
    }
    case actions.ACTION_UPDATE_START_DATE_OPTION: {
      return {
        ...state,
        startDateOptionSelected : action.data,
      };
    }
    case actions.ACTION_SET_APP_VERSION: {
      return {
        ...state,
        appVersion: action.data,
      };
    }
    case actions.ACTION_REDIRECT_FROM_SEO: {
      return {
        ...state,
        ...action.data,
      };
    }
    default:
      return state;
  }
};
